export default __webpack_public_path__ + "static/media/portfolio-209.5b640d8f.jpg";